import { configureStore } from "@reduxjs/toolkit";
import { serverApi } from "../api/serverApi";
import { setupListeners } from "@reduxjs/toolkit/query";
import mainSlice, { mainInitialState } from "./slices/mainSlice";
import authSlice, { authInitialState } from "./slices/authSlice";
import testCaseTemplateSlice from "./slices/testCaseTemplateSlice";
import scenarioSlice from "./slices/scenarioSlice";
import testPlanSlice from "./slices/testPlanSlice";
import testCaseIncomingSlice from "./slices/testCaseIncomingSlice";
import { middleware } from "./middleware/apiMiddleware";

const loadMainSlice = () => {
  const result = mainInitialState;

  const projectName = localStorage.getItem("projectName");
  if (!!projectName) {
    result.projectName = projectName;
  }
  const login = localStorage.getItem("login");
  if (!!login) {
    result.login = login;
  }

  const projectsSettingsStr = localStorage.getItem("projectsSettings");
  if (!!projectsSettingsStr) {
    result.projectsSettings = JSON.parse(projectsSettingsStr);
  }
  return result;
}

const loadAuthSlice = () => {
  const result = authInitialState;
  const token = localStorage.getItem("token");
  if (!!token) {
    result.token = token;
  }
  const isSandbox = localStorage.getItem("isSandbox");
  if (!!isSandbox) {
    result.isSandbox = +isSandbox === 1
  }
  return result;
}

export const store = configureStore({
  reducer: {
    [serverApi.reducerPath]: serverApi.reducer,

    authSlice,
    mainSlice,
    testCaseTemplateSlice,
    scenarioSlice,
    testPlanSlice,
    testCaseIncomingSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ immutableCheck: false }).concat(
      middleware,
    ),
  preloadedState: {
    mainSlice: loadMainSlice(),
    authSlice: loadAuthSlice()
  }
});

store.subscribe(() => {
  const mainSliceState = store.getState().mainSlice;
  localStorage.setItem("projectsSettings", JSON.stringify(mainSliceState.projectsSettings));
  mainSliceState.projectName && localStorage.setItem("projectName", mainSliceState.projectName);
  mainSliceState.login && localStorage.setItem("login", mainSliceState.login);

  const authSliceState = store.getState().authSlice;
  authSliceState.token && localStorage.setItem("token", authSliceState.token);
  authSliceState.isSandbox != null && localStorage.setItem("isSandbox", authSliceState.isSandbox ? "1" : "0");
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;